export default __webpack_public_path__ + "static/media/texp11.8a7525a7.png";